import { useEffect, useState } from "react";
import {
  Breadcrumb,
  Typography,
  Image,
  Layout,
  Skeleton,
  Card,
  Tag,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useHttp } from "../../../utils/DataHendler";
import CustomHeader2 from "../../landingpage/Header/CustomHeader2";
import { Footers } from "../../Footers";
import { formatDate } from "../../../utils/DateTime";

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const ArticleDetail = () => {
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState({});
  const [loading, setLoading] = useState(false);
  const { getData } = useHttp();
  const { id } = useParams();

  useEffect(() => {
    getEvent();
    // eslint-disable-next-line
  }, [id]);

  const getEvent = async () => {
    setLoading(true);
    try {
      const response = await getData(`/event/${id}`, {}, true);
      setDetailData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f7f8fa" }}>
      <CustomHeader2 />

      {/* Breadcrumb */}
      <div style={{ padding: "24px 0 0 0", maxWidth: 900, margin: "0 auto" }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/")}>Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/event")}>Media</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Artikel</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Layout style={{ background: "transparent", padding: "32px 0", flex: 1 }}>
        <Content style={{ maxWidth: 900, margin: "0 auto" }}>
          <Card
            bordered={false}
            style={{
              borderRadius: 18,
              boxShadow: "0 6px 28px rgba(0,0,0,0.06)",
              padding: 0,
              background: "#fff",
            }}
            bodyStyle={{ padding: "40px 40px 48px 40px" }}
          >
            {/* Title */}
            {loading ? (
              <Skeleton.Input
                active
                size="large"
                style={{ width: "80%", marginBottom: 12 }}
              />
            ) : (
              <Title
                level={2}
                style={{
                  marginTop: 4,
                  marginBottom: 8,
                  lineHeight: 1.2,
                  color: "#222",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  textAlign: "center",
                }}
              >
                {detailData?.name}
              </Title>
            )}

            {/* Short description */}
            {loading ? (
              <Skeleton active paragraph={{ rows: 2 }} />
            ) : (
              detailData?.title && (
                <Title
                  level={4}
                  style={{
                    marginTop: 8,
                    marginBottom: 12,
                    color: "#222",
                    fontWeight: 600,
                  }}
                >
                  {detailData?.title}
                </Title>
              )
            )}

            {/* Tags */}
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              {loading ? (
                <Skeleton.Button
                  active
                  style={{ width: 100, marginRight: 8 }}
                />
              ) : (
                detailData?.tags?.map((tag, i) => (
                  <Tag
                    key={i}
                    color={
                      i % 2 === 0 ? "blue" : i % 3 === 0 ? "green" : "volcano"
                    }
                    style={{
                      padding: "4px 12px",
                      fontWeight: 500,
                      fontSize: 13,
                      borderRadius: 6,
                      margin: "0 4px",
                    }}
                  >
                    {tag}
                  </Tag>
                ))
              )}
            </div>

            {/* Main image */}
            <div style={{ position: "relative", marginBottom: 32 }}>
              {loading ? (
                <Skeleton.Image
                  active
                  style={{
                    width: "100vh",
                    height: 250,
                    borderRadius: 16,
                  }}
                />
              ) : (
                <>
                  <Image
                    src={detailData?.top_image}
                    alt={detailData?.name}
                    style={{
                      width: "100vh",
                      height: 250,
                      objectFit: "cover",
                      borderRadius: 10,
                      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                    }}
                    preview={true}
                  />
                  {/* Date badge di pojok kanan bawah gambar */}
                  {detailData?.created_at && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 18,
                        right: 18,
                        zIndex: 2,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          background: "rgba(0,0,0,0.7)",
                          color: "#fff",
                          padding: "6px 16px",
                          borderRadius: 10,
                          fontSize: 14,
                          fontWeight: 500,
                          letterSpacing: 0.5,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                        }}
                      >
                        {formatDate(detailData?.created_at)}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Body content */}
            {loading ? (
              <Skeleton active paragraph={{ rows: 6 }} />
            ) : (
              <div>
                <Paragraph
                  style={{
                    fontSize: 16,
                    lineHeight: 1.8,
                    color: "#333",
                    textAlign: "justify",
                    marginBottom: 24,
                  }}
                >
                  {detailData?.description}{" "}
                </Paragraph>
                {/* Quote Section */}
                {detailData?.quote && (
                  <div
                    style={{
                      background: "#f4f8ff",
                      borderLeft: "4px solid #1890ff",
                      padding: "18px 24px",
                      borderRadius: 10,
                      margin: "24px 0",
                      fontStyle: "italic",
                      fontSize: 17,
                      color: "#222",
                      fontWeight: 500,
                    }}
                  >
                    “{detailData?.quote}”
                  </div>
                )}
              </div>
            )}
          </Card>
        </Content>
      </Layout>

      <Footers />
    </div>
  );
};

export default ArticleDetail;
